import React, { useState } from 'react';
// import { createBrowserHistory } from "history";
// const history = createBrowserHistory();
import firebase from '../config/firebase';
import {_Alert} from '../config/projectConfig';

export default function Page() {
  return ( <Main/>)
};
function Main() {
  const [state, setState] = useState({});

  const handleChange = (key, value) => {
    var temp = state;
    temp[key] = value;
    setState(temp);
  }
  const handleSubmit = (event) => {
    console.log('event........ =',JSON.stringify(state));
    const data = new FormData(event.target);
    var full_message = [
      "",
      "Topic : "+(data.get('topic') != null ? data.get('topic') : ""),

      "Name  : "+(data.get('name') != null ? data.get('name') : ""),
      "Mobile: "+(data.get('mobile') != null ? data.get('mobile') : ""),
      "LineID: "+(data.get('lineId') != null ? data.get('lineId') : ""),
      "Email : "+(data.get('email') != null ? data.get('email') : ""),

      "Messages: "+(data.get('messages') != null ? data.get('messages') : "")
    ].join('\n');
      alert('A name was submitted: ' + full_message);
    // var addMessage = firebase.functions().httpsCallable('lineNotify');
    // var addMessage = firebase.functions().httpsCallable('lineNotify_contact');
    // var addMessage = firebase.functions().httpsCallable('lineNotsaveContactAndLineNotifyify');
    console.log( "message" , "send and save data" );
    // addMessage({text:full_message}).then(function(result) {
    //   console.log( "result" , "ok" );
    //   // Read result of the Cloud Function.
    //   console.log( "result",result);
    //   var sanitizedMessage = result.data.text;
    //   console.log( "sanitizedMessage" , sanitizedMessage );
    // }).catch(function(error) {
    //   // Getting the Error details.
    //   var code = error.code;
    //   console.log( "code" , code );
    //   var message = error.message;
    //   console.log( "message" , message );
    //   var details = error.details;
    //   console.log( "details" , details );
    //   // ...
    // });
    // alert('ขอบคุณสำหรับข้อมูล แล้วเราจะติดต่อกลับ');
    _Alert("info","Thank You","ขอบคุณสำหรับข้อมูล แล้วเราจะติดต่อกลับ");
    event.preventDefault();
  }

  {return <>
      <div className="c-content-box c-size-md c-bg-white">
          <div className="container">
            <div className="c-content-feedback-1 c-option-1">
              <div className="row">
                <div className="col-md-6 offset-md-3">
                  <div className="c-contact">
                    <div className="c-content-title-1">
                      <h3 className="c-font-uppercase c-font-bold">ลงชื่อติดต่อ</h3>
                      <div className="c-line-left"></div>
                      {/* <p className="c-font-lowercase">Our helpline is always open to receive any inquiry or feedback.
                      Please feel free to drop us an email from the form below and we will get back to you as soon as we can.</p> */}
                    </div>
                    <form onSubmit={ (e) => handleSubmit(e)} >
                      <input type="hidden" name="topic" value="Customer request call back." />
                        <div className="form-group">
                          <input type="text" name="name" placeholder="Your Name" className="form-control c-square c-theme input-lg" onChange={(e) => handleChange(e.target.name, e.target.value) } />
                        </div>
                        <div className="form-group">
                          <input type="text" name="mobile" placeholder="Contact Phone" className="form-control c-square c-theme input-lg" onChange={(e) => handleChange(e.target.name, e.target.value) } />
                        </div>
                        <div className="form-group">
                          <input type="text" name="lineId" placeholder="LineID" className="form-control c-square c-theme input-lg" onChange={(e) => handleChange(e.target.name, e.target.value) } />
                        </div>
                        <div className="form-group">
                          <input type="text" name="email" placeholder="Your Email" className="form-control c-square c-theme input-lg" onChange={(e) => handleChange(e.target.name, e.target.value) } />
                        </div>
                        <div className="form-group">
                              <textarea rows="3" name="messages" placeholder="Write comment here ..." className="form-control c-theme c-square input-lg" onChange={(e) => handleChange(e.target.name, e.target.value) }></textarea>
                        </div>
                        <button type="submit" className="btn btn-primary">Submit</button> 
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div> 
        </div>
    </>
  }
}